
  import Vue from 'vue'
  import UserService from '@/services/UserService';
import { extractErrorMessage } from '@/utils/Util';

  export default Vue.extend({
    name: 'UserResendInviteDialog',
    props: ['user'],
    data: () => ({
        localDialog: false,
        alertText: "",
        alertVisible: false,
        alertType: "error",
        loading: false,
        userTenant: {} as any,
    }),
    methods: {
      close() {
        this.localDialog = false;
      },
      clear() {
        this.alertVisible = false;
        this.loading = false;
      },
      dismiss() {
        this.clear();
        this.close();
      },
      async confirmResend() {
        this.loading = true;

        try {
            await UserService.resendInvite(this.user.uuid);

            this.alertType = "success";
            this.alertText = this.$t('user.successResendInvite') as string;
            this.alertVisible = true;
            this.loading = false;

            setTimeout(() => { 
                this.dismiss(); 
            }, 2000);
        } catch(err: any) {
            console.log(err);
            console.log(err.response);
            this.alertType = "error";
            this.alertText = this.$t('user.errorResendInvite') + ' ' + extractErrorMessage(err);
            this.alertVisible = true; 
            this.loading = false;
        }
      }
    },
    watch: {
        async localdialog(value: boolean) {
            if(!value) {
                this.clear();
            }
        }
    },
  })
